import React from 'react';
import Inbox from "pages/Inbox";
import {
    EventNote,
    FavoriteBorder,
    FileCopy,
    FormatListNumbered,
    MailOutline,
    MenuBook,
    Restore
} from '@material-ui/icons';
import UpcomingAppointments from "pages/Appointments/UpcomingAppointments";
import ViewUpcomingDetail from "pages/Appointments/UpcomingAppointments/View";
import Messages from 'pages/Messages/Details';
import {useTranslation} from 'react-i18next';
import Resources from "../pages/Resources/Resources";
import Forms from "pages/Forms/Forms";
import Tasks from "pages/Tasks/Tasks";
import {Badge} from "antd";
import { useQuery } from 'react-query';
import { getIncompletePatientTasks } from 'api/patientTasks';
import { getIncompleteFormSubmissions } from 'api/formSubmissions';
import { useAppSelector } from '../hooks/use-app-selector';
import AppointmentsModule from 'modules/AppointmentsModule';
import { UPCOMING } from 'constants/appointment-constants';
import { PAST } from 'constants/appointment-constants';
import Heartrate from "../pages/Heartrate";
import {MdAddToQueue, MdQueue} from "react-icons/all";
import ReferralBookingPage from "../pages/ReferralBooking";

const REFETCH_INTERVAL_IN_MILLISECONDS = 60000;

const Translate = (prop: any) => {
    const { t } = useTranslation();

    return <>{t(prop.keyword)}</>;
};

const Routes = (enableQuery = false) => {
    const { t } = useTranslation();

    const permissions = useAppSelector(state => state.permissions.permissions);

    const { data: incompletePatientTasks } = useQuery('getIncompletePatientTasks', async () => {
        return await getIncompletePatientTasks();
    }, {
        refetchInterval: REFETCH_INTERVAL_IN_MILLISECONDS,
        enabled: enableQuery
    })

    const { data: incompleteFormSubmissions } = useQuery('getIncompleteFormSubmissions', async () => {
        return await getIncompleteFormSubmissions();
    }, {
        refetchInterval: REFETCH_INTERVAL_IN_MILLISECONDS,
        enabled: enableQuery
    })

    return ([
        permissions.Appointments ? {
            className: 'upcoming-appointments-link',
            path: '/upcoming-appointments',
            title: <Translate keyword='label.upcoming_appointments' />,
            bottomTitle: t('label.upcoming_appointments'),
            icon: <EventNote fontSize='large' />,
            component: <AppointmentsModule span={UPCOMING} />,
            components: [
                {
                    path: '/:id',
                    title: 'Appointment Details',
                    component: <ViewUpcomingDetail />,
                }
            ]
        } : null,
        permissions.Appointments ? {
            className: 'past-appointments-link',
            path: '/past-appointments',
            title: <Translate keyword='label.past_appointments' />,
            bottomTitle: t('label.past_appointments'),
            icon: <Restore fontSize='large' />,
            component: <AppointmentsModule span={PAST} />,
            components: [
                {
                    path: '/:id',
                    title: 'Appointment Details',
                    component: <ViewUpcomingDetail />,
                }
            ]
        } : null,
        permissions.Inbox ? {
            className: 'inbox-link',
            path: '/inbox',
            title: <Translate keyword='label.inbox' />,
            bottomTitle: t('label.inbox'),
            icon: <MailOutline fontSize='large' />,
            component: <Inbox />,
            breadcrumbName: 'Inbox',
            components: [
                {
                    path: '/:id',
                    title: '',
                    component: <Messages />,
                }
            ]
        } : null,
        permissions.Inbox ? {
            className: 'heartrate-link',
            path: '/heartrate',
            title: <Translate keyword='label.heartrate' />,
            icon: <FavoriteBorder fontSize='large' />,
            component: <Heartrate />,
            breadcrumbName: 'Heartrate',
            components: [
                {
                    path: '/:id',
                    title: '',
                    component: <Heartrate />,
                }
            ]
        } : null,
        permissions.Resources ? {
            className: 'resource-link',
            path: '/resources',
            title: <Translate keyword='label.collateral' />,
            icon: <MenuBook fontSize='large' />,
            component: <Resources />,
            breadcrumbName: 'Resources',
        } : null,
        permissions.Forms ? {
            className: 'form-link',
            path: '/forms',
            title: <Translate keyword='label.form_plural' />,
            icon: <Badge count={incompleteFormSubmissions?.data}><FileCopy fontSize='large' /></Badge>,
            component: <Forms />,
            breadcrumbName: 'Forms',
        } : null,
        permissions.Tasks ? {
            className: 'task-link',
            path: '/tasks',
            title: <Translate keyword='label.task' />,
            icon: <Badge count={incompletePatientTasks?.data}><FormatListNumbered fontSize='large'/></Badge>,
            component: <Tasks />,
            breadcrumbName: 'Tasks',
        } : null,
        {
            path: '/referral-booking',
            title: "Referral Booking",
            icon: <MdAddToQueue fontSize='large' />,
            component: <ReferralBookingPage />,
            show: false
        }
    ]).filter(element => element);
}

export default Routes;